import {
  Banner,
  BannerContent,
  BannerDescription,
  BannerTitle,
} from '@heidi/design-system/banner';
import { FormattedMessage } from 'react-intl';

import type { JSX } from 'react';

/**
 * EVI-1567 / EV-023 drug-interaction safety disclaimer, shared by the legacy
 * Chat answer renderer and the harness-backed Evidence child timeline.
 *
 * Moved from `src/components/chat/components/components.tsx` for AGE-2151.
 * Both paths render this one component so they cannot drift: same test id,
 * spacing, and non-dismissible Banner. English copy is the EVI-1567 catalog
 * string (`askAI.drugInteractionWarning`), not a rewrite of the warning.
 */
export const DrugInteractionWarningBanner = (): JSX.Element => {
  return (
    <Banner subVariant="warning" className="mt-3" data-testid="drug-interaction-warning">
      <BannerContent>
        <BannerTitle>
          <FormattedMessage
            defaultMessage="Verify drug interactions"
            id="Udo3NB8ZQR"
            description="Title of the drug-interaction safety disclaimer on Evidence answers"
          />
        </BannerTitle>
        <BannerDescription>
          <FormattedMessage
            defaultMessage="Always verify drug interactions with a dedicated checker; absence of warning does not confirm safety."
            id="tKzVFvuTRh"
            description="EVI-1567 / EV-023 body copy; keep in lockstep with askAI.drugInteractionWarning"
          />
        </BannerDescription>
      </BannerContent>
    </Banner>
  );
};
